import { Typography, Box, Icon, Select, MenuItem, Button } from '@mui/material';
import { useState } from 'react';
import { useTheme } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { formatDateToJalali, numberToTomans } from '../../../utils/helpers';
import { GOLD_BOX_STATUS } from '../../../utils/constants';
import Badge from '../../base/BaseBadge/BaseBadge';
import BaseDialog from '../../base/BaseDialog/BaseDialog';
import { BaseButton, BaseInput } from '../../base';
import { useNotification } from '../../../context/NotificationProvider';
import useProtectedClient from '../../../hooks/useProtectedClient';
import { changeGoldBoxItemStatus } from '../../../api/admin/adminGoldBoxApi';

const AdminProductCard = ({ item }) => {
    const theme= useTheme();
    const [isLoading, setIsLoading] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const {showNotification} = useNotification();
    const protectedClient = useProtectedClient();
    const [selectedStatus, setSelectedStatus] = useState(item?.status);
    const [serialNumber, setSerialNumber] = useState(item?.serialNumber);

    const handleConfirm = async () => {
        setIsLoading(true);
        try {
            await changeGoldBoxItemStatus(protectedClient, item._id, selectedStatus, serialNumber)
            showNotification("با موفقیت به روز شد", "success");
        } catch (error) {
            showNotification(error, "error");
        } finally {
            setDialogOpen(false);
            setIsLoading(false);
            window.location.reload();
        }
    };

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    const getBadgeProps = (status) => {
        return { type: GOLD_BOX_STATUS[status].type, text: GOLD_BOX_STATUS[status].title }
    };
    const handleStatusChange = (event) => {
        setSelectedStatus(event.target.value);
    };
    const badgeProps = getBadgeProps(item.status);
    const dialogRows = [
        {
            title: "نوع: ",
            value: `${item?.productName}`
        },
        {
            title: "سریال: ",
            value: (
                <BaseInput
                    value={serialNumber}
                    onChange={(e) => setSerialNumber(e.target.value)}
                    name="displayName"
                    type="text"
                />
            )
        },
        {
            title: "به نام: ",
            value: `${item?.customer.profile.displayName}`
        },
        {
            title: "شماره تماس:",
            value: `${item?.customer.profile.phone}`
        },
        {
            title: "وضعیت: ",
            value: (
                <Select
                    value={selectedStatus}
                    onChange={handleStatusChange}
                    variant="outlined"
                    size="small"
                >
                    {Object.entries(GOLD_BOX_STATUS).map(([key, { title }]) => (
                        <MenuItem key={key} value={key}>
                        {title}
                        </MenuItem>
                    ))}
                </Select>
            )
        },
        {
            title: "تاریخ ایجاد:",
            value: `${formatDateToJalali(item?.createdAt)}`
        },
        {
            title: "تاریخ آخرین تغییرات: ",
            value: `${formatDateToJalali(item?.updatedAt)}`
        },
    ];
    return (
    <>
        <BaseDialog
            isOpen={dialogOpen}
            handleClose={handleDialogClose}
            title="جزییات آیتم"
        >
            {dialogRows.map((row, index) => (
                <Box
                    key={index}
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                        width: '100%',
                        padding: '10px'
                    }}
                >
                    <Typography
                        variant='caption2'
                    >
                        {row.title}
                    </Typography>
                    <Typography
                        variant='caption2'
                    >
                        {row.value}
                    </Typography>
                </Box>
            ))}
            <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    width: '100%',
                    padding: '10px'
                }}
            >
                <BaseButton
                    onClick={() => handleConfirm()}
                    isLoading={isLoading}
                    sx={{
                        margin: "10px",
                        backgroundColor: theme.palette.success.main,
                        color: theme.palette.text.secondary
                    }}
                >
                    بروزرسانی
                </BaseButton>
            </Box>
        </BaseDialog>
        <Button
            onClick={() => handleDialogOpen(item)}
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                margin: "5px 0",
                padding: "10px",
                borderRadius: "10px",
                border: "1px solid"
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="flex-start"
                gap={2}
                sx={{ width: "50%", flexGrow: 1 }}
            >
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Typography
                        variant='caption2'
                    >
                        {item.productType === 0 ? `${item.amount} گرم ${item.productName}` :  item.productName}
                    </Typography>
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                >
                    <Typography
                        variant='caption2'
                        sx={{
                            color: theme.palette.text.gray
                        }}
                    >
                        {`به نام: ${item.customer.profile.displayName}`}
                    </Typography>
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                >
                    <Typography
                        variant='caption2'
                        sx={{
                            color: theme.palette.text.gray
                        }}
                    >
                        {`${item.customer.profile.phone}`}
                    </Typography>
                </Box>
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                gap={1}
                sx={{ width: "40%", flexGrow: 1 }}
            >
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                >
                    <Badge {...badgeProps} />
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Typography
                        variant='caption2'
                    >
                        {`سریال: ${item.serialNumber}`}
                    </Typography>
                </Box>
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="center"
                gap={2}
                sx={{ width: "5%", flexGrow: 1 }}
            >
                <Icon
                    sx={{
                        display: 'flex',
                        fontSize: 24,
                        color: theme.palette.background.gray,
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <ChevronLeftIcon/>
                </Icon>
            </Box>
        </Button>
    </>
    );
};

export default AdminProductCard;
